import React from "react";
import { Link } from "react-router-dom";
import "./common.css";

const classifiedData = [
  {
    _id: "b1234567890lionel",
    name: "Lionel Jenifer",
    email: "lionel@gmail.com",
    password: "9600803023",
    mobileNumber: "9600803023",
    companyName: "SRV Honey Processing Industry",
    productOrService: "Honey",
    imgSrc: "/assets/honey.jpg", // Make sure to add a relevant image
    mainProducts: "Pure Honey, Organic Honey, Flavored Honey",
    altText: "SRV Honey Processing Industry - Honey",
    years: "1 YRS",
    location: "Kanyakumari, Tamil Nadu, India",
    tooltipText: "SRV Honey Processing Industry, Kanyakumari, Tamil Nadu",
    rating: "4.9",
    ratingPercent: "97%",
    ratingsCount: "150",
    responseRate: "92%",
    whatsappConfirmed: true,
  },
  {
    _id: "well-fine-honey-kashmir",
    name: "Faisal",
    email: "Faisal123@gmail.com",
    password: "Faisal1234",
    mobileNumber: "9103137508",
    companyName: "Well Fine Honey",
    statename: "Srinagar",
    cityname: "Kashmir",
    productOrService: "Honey",
    imgSrc: "/assets/honey1.jpg",
    mainProducts: "Premium Honey",
    altText: "Well Fine Honey - Premium Honey Supplier in Kashmir",
    years: "1 YRS",
    location: "Kashmir, Srinagar, India",
    tooltipText: "Well Fine Honey - Trusted Source for Pure Honey",
    rating: "4.7",
    ratingPercent: "93%",
    ratingsCount: "180",
    responseRate: "89%",
    whatsappConfirmed: true,
  },
  {
    _id: "prosper-tree-impex",
    name: "Mr. Ranjith Antony",
    email: "7094961166@gmail.com",
    password: "7094961166",
    mobileNumber: "7094961166",
    companyName: "PROSPER TREE IMPEX",
    statename: "Tamil Nadu",
    cityname: "Coimbatore",
    productOrService: " Honey, Cashew Nuts",
    imgSrc: "/assets/honey3.jpg",
    mainProducts: "Coconut Products, Spices, Honey, Cashew Nuts",
    altText:
      "PROSPER TREE IMPEX - Supplier of Coconut Products, Spices, Honey, Cashew Nuts",
    years: "1 YRS",
    location: "Coimbatore, Tamil Nadu, India",
    tooltipText:
      "Mr. Ranjith Antony - Specialist in Coconut Products, Spices, Honey, Cashew Nuts",
    rating: "4.8",
    ratingPercent: "96%",
    ratingsCount: "49",
    responseRate: "92%",
    whatsappConfirmed: true,
  },

  // Add more items if needed
];

const HoneyComponent = () => {
  return (
    <div className="main-box">
      <aside>
        <div className="flt-box-wrap">
          <div className="flt-box mb-0 flt-head">Filters By</div>
          <div className="flt-box bdrt-0">
            <p className="flt-title">Related Categories</p>
            <div className="flt-content">
              <ul className="flt-list cust-scroll">
                <li>
                  <Link to="#">Pure Honey</Link>
                </li>
                <li>
                  <Link to="#">Organic Honey</Link>
                </li>
                <li>
                  <Link to="#">Flavored Honey</Link>
                </li>
                <li>
                  <Link to="#">Honeycomb</Link>
                </li>
                <li>
                  <Link to="#">Honey Sticks</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="flt-box">
            <p className="flt-title">By State</p>
            <div className="flt-content">
              <div className="flt-search">
                <input
                  type="text"
                  name="state_id"
                  placeholder="Search State"
                  id="state-search-input"
                />
              </div>
              <ul className="flt-list cust-scroll" id="state-lists">
                <li>
                  <Link to="#">All India</Link>
                </li>
                <li>
                  <Link to="#">Gujarat</Link>
                </li>
                <li>
                  <Link to="#">Maharashtra</Link>
                </li>
                <li>
                  <Link to="#">Karnataka</Link>
                </li>
                <li>
                  <Link to="#">Punjab</Link>
                </li>
                <li>
                  <Link to="#">Uttar Pradesh</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>
      <main>
        <section className="section">
          <p className="sect-title">Explore by Categories</p>
          <div className="horprd expcatg" id="expcatg">
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/honey.jpg"
                      width={55}
                      height={55}
                      alt="Honey"
                    />
                  </figure>
                  <p className="title">Pure Honey</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/organichoney.jpg"
                      width={55}
                      height={55}
                      alt="Honey"
                    />
                  </figure>
                  <p className="title">Organic Honey</p>
                </div>
              </Link>
            </div>
            {/* Add more categories if needed */}
          </div>
        </section>
        <ul className="classfied-wrap">
          {classifiedData.map((item, index) => (
            <li key={index}>
              <div className="classified">
                <div className="prd-info">
                  <div className="prd-box">
                    <img
                      src={item.imgSrc}
                      alt={item.altText}
                      width={250}
                      height={250}
                    />
                  </div>
                </div>
                <div className="cinfo">
                  <div className="cbox">
                    <figure>
                      <span className="cmp-year">{item.years}</span>
                    </figure>
                    <div className="cboxr">
                      <Link to="#" target="_blank">
                        <h4 className="title">{item.companyName}</h4>
                      </Link>
                      <p className="cloc tooltip ellipsis">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          fill="currentColor"
                          className="bi-location"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                        {item.location}
                        <span className="tooltiptext">{item.tooltipText}</span>
                      </p>
                      <div className="rating-wrap">
                        <span className="rtbox">{item.rating}</span>
                        <span
                          className="crate"
                          style={{ "--_score": item.ratingPercent }}
                        />
                        <span className="rate-text">
                          {item.ratingsCount} Ratings
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="caddit">
                    <div className="item">
                      <div
                        className="ca-box modal-btn"
                        data-modal="motc"
                        data-src={item.trustCertificateUrl}
                      >
                        <p>
                          <i className="l3icon motc-icon" />
                        </p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="ca-box">
                        <p>
                          <i className="l3icon resp-icon" />
                        </p>
                        <p>
                          <span>Response Rate</span> <b>{item.responseRate}</b>
                        </p>
                      </div>
                      <p>
                        <span>Main Products</span> <b>{item.mainProducts}</b>
                      </p>
                    </div>
                  </div>
                  <div className="caction">
                    <Link to={"/register-buyer"}>
                      <p>Contact Supplier</p>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default HoneyComponent;
